import './App.css';
import { Routes, Route } from "react-router-dom";
import Home from './Pages/home';
import Cechoii from './Pages/cecholl';
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap";
import Nimar from './Pages/nimar';
import News from './Pages/news';
import Contact from './Pages/contact';
import RoutesPage from './Pages/routespage';
import Signup from './Pages/signup';
import Login from './Pages/login';
import Bookings from './Pages/bookings';
import ContactUs from './Pages/contactUs';

function App(props) {

  return (
    <Routes>
      <Route path="/" element={<Home db={props.db} auth={props.auth}/>} />
      <Route path="/cechoii" element={<Cechoii db={props.db} auth={props.auth}/>} />
      <Route path="/nimar" element={<Nimar db={props.db} auth={props.auth}/>} />
      <Route path="/news" element={<News db={props.db} auth={props.auth}/>} />
      <Route path="/contact" element={<Contact db={props.db} auth={props.auth}/>} />
      <Route path="/routes" element={<RoutesPage db={props.db} auth={props.auth}/>} />
      <Route path="/signup" element={<Signup db={props.db} />} auth={props.auth}/>
      <Route path="/login" element={<Login db={props.db} />} auth={props.auth}/>
      <Route path="/bookings" element={<Bookings db={props.db} auth={props.auth}/>} />
      <Route path="/contactus" element={<ContactUs db={props.db} auth={props.auth}/>} />
    </Routes>
  );
}

export default App;
